import { useDispatch, useSelector } from 'react-redux'

import { DeviceDrawer } from '@/features/device-drawer'
import { IncidentDrawer } from '@/features/incident-drawer'
import { SOPModal } from '@/features/sop-drawer'
import { SubmittedTourDrawer } from '@/features/submitted-tour-drawer'
import {
  closeDeviceDrawer,
  closeIncidentDrawer,
  closeSOPModal,
  closeSubmittedTourDrawer,
  closeTraceLogDrawer,
  selectIsDeviceDrawerOpen,
  selectIsIncidentDrawerOpen,
  selectIsSOPModalOpen,
  selectSubmittedTourOpen,
  setDevice,
  setIncident,
  setSOP,
  setSubmittedTourId,
} from '@/redux/ui/uiSlice'

export const Drawers = () => {
  const dispatch = useDispatch()

  const handleCloseDeviceDrawer = () => {
    dispatch(setDevice({ id: null, type: null }))
    dispatch(closeDeviceDrawer())
  }

  const handleCloseIncidentDrawer = () => {
    dispatch(setIncident({ id: null }))
    dispatch(closeIncidentDrawer())
    dispatch(closeTraceLogDrawer())
  }

  const handleCloseSOPModal = () => {
    dispatch(setSOP({ id: null }))
    dispatch(closeSOPModal())
  }

  const handleCloseSubmittedTourDrawer = () => {
    dispatch(setSubmittedTourId({ id: null }))
    dispatch(closeSubmittedTourDrawer())
  }

  const isIncidentDrawerOpen = useSelector(selectIsIncidentDrawerOpen)
  const isDeviceDrawerOpen = useSelector(selectIsDeviceDrawerOpen)
  const isSOPModalOpen = useSelector(selectIsSOPModalOpen)
  const isSubmittedTourOpen = useSelector(selectSubmittedTourOpen)

  return (
    <>
      {isIncidentDrawerOpen && (
        <IncidentDrawer
          isOpen={isIncidentDrawerOpen}
          onClose={handleCloseIncidentDrawer}
        />
      )}
      {isDeviceDrawerOpen && (
        <DeviceDrawer
          isOpen={isDeviceDrawerOpen}
          onClose={handleCloseDeviceDrawer}
        />
      )}
      {isSOPModalOpen && (
        <SOPModal isOpen={isSOPModalOpen} onClose={handleCloseSOPModal} />
      )}
      {isSubmittedTourOpen && (
        <SubmittedTourDrawer
          isOpen={isSubmittedTourOpen}
          onClose={handleCloseSubmittedTourDrawer}
        />
      )}
    </>
  )
}
